export const BUTTON_HEIGHT = {
  small: 30,
  medium: 35,
  large: 45,
};
